const images=[
    {'Action': 'https://image.tmdb.org/t/p/w500//iUgygt3fscRoKWCV1d0C7FbM9TP.jpg'},
    {'Adventure': 'https://image.tmdb.org/t/p/w500//jKuDyqx7jrjiR9cDzB5pxzhJAdv.jpg'},
    {'Animation': 'https://image.tmdb.org/t/p/w500//ld7YB9vBRp1GM1DT3KmFWSmtBPB.jpg'}, 
    {'Comedy':'https://image.tmdb.org/t/p/w500//xmbU4JTUm8rsdtn7Y3Fcm30GpeT.jpg'},
    {'Crime':'https://image.tmdb.org/t/p/w500//M7SUK85sKjaStg4TKhlAVyGlz3.jpg'}, 
    {'Documentary' : 'https://image.tmdb.org/t/p/w500//g1xiBoLD6v3ZaXPa4QtuXiQeYKW.jpg'},
    {'Drama' : 'https://image.tmdb.org/t/p/w500//gII53HAH7UA1yx189vROMzWA5ib.jpg'},
    {'Family' : 'https://image.tmdb.org/t/p/w500//tbVZ3Sq88dZaCANlUcewQuHQOaE.jpg'},
    {'Fantasy' : 'https://image.tmdb.org/t/p/w500//nkayOAUBUu4mMvyNf9iHSUiPjF1.jpg'},
    {'History' : 'https://image.tmdb.org/t/p/w500//gIECF0d3fri7yryBwMfHJxKAHdE.jpg'},
    {'Horror' : 'https://image.tmdb.org/t/p/w500//lHV8HHlhwNup2VbpiACtlKzaGIQ.jpg'},
    {'Music' : 'https://image.tmdb.org/t/p/w500//lHu1wtNaczFPGFDTrjCSzeLPTKN.jpg'},
    {'Mystery' : 'https://image.tmdb.org/t/p/w500//h7dZpJDORYs5c56dydbrLFkEXpE.jpg'},
    {'Romance' : 'https://image.tmdb.org/t/p/w500//kiX7UYfOpYrMFSAGbI6j1pFkLzQ.jpg'},
    {'Science Fiction' : 'https://image.tmdb.org/t/p/w500//niw2AKHz6XmwiRMLWaoyAOAti0G.jpg'},
    {'Thriller' : 'https://image.tmdb.org/t/p/w500//8NUM43rtQSt0chumXGJPvnYb01I.jpg'},
    {'War' : 'https://image.tmdb.org/t/p/w500//fTuxNlgEm04PPFkr1xfK94Jn8BW.jpg'},
    {'Western' : 'https://image.tmdb.org/t/p/w500//19VaTIO5e9MfoXxIMALaEaiGAIN.jpg'},
]

export {images}